import type { PageLayoutProps } from "../../contract.js";
import type { HomeContent } from "../../pages/home/contract.js";

/** The classic home page: a hero, three promo cards, best recent opens, the featured packs, and the FAQ. */
export function ClassicHomeLayout({ sections }: PageLayoutProps<HomeContent>) {
  return (
    // `grid-cols-1` is `minmax(0, 1fr)`: an implicit `auto` column grows to fit the widest row, so a
    // long carousel would widen every section past the page instead of scrolling.
    <div className="grid grid-cols-1 gap-10 md:gap-16">
      {sections.hero}
      {sections.promoCards}
      {sections.recentOpens}
      {sections.featuredBoxes}
      {sections.faq}
    </div>
  );
}
